"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.error.failedToLoad': 'Error al cargar las conversaciones',
    'conversations.error.failedToDelete': 'Error al eliminar la conversación',
    'conversations.error.failedToToggleFavorite': 'Error al cambiar el estado de favorito',
};
